import koalition from '../../../api/koalition'
import useFormBuilder from '../../../hooks/FormBuilderHook'
import Input from '../../forms/Input/Input'
import Select from '../../forms/Select/Select'
import Validators from '../../../forms/Validators'
import { useModal } from '../../../contexts/Modal'
import { useData } from '../../../contexts/Data'
import { useUser } from '../../../contexts/User'
import { useEffect, useRef, useState } from 'react'
import { useToaster } from '../../../contexts/Toaster'
import { useCharacters } from '../../../contexts/Characters'

const NewCharacter = ({}) => {
    const formName = 'newCharacter'
    const modal = useModal()
    const data = useData()
    const user = useUser()
    const toaster = useToaster()
    const characters = useCharacters()
    const [serverOptions, setServerOptions] = useState([])
    const [allianceOptions, setAllianceOptions] = useState({})
    const [currentServer, setCurrentServer] = useState()
    const noAllianceOption = { value: null, label: 'No Alliance' }

    const createCharacterRef = useRef()
    createCharacterRef.current = () => {
        const formValues = form.$state.value

        const character = {
            ...formValues,
            user: user.$state._id,
            default: false,
        }

        koalition.post('/characters', character).then((response) => {
            characters.user([ ...characters.$state.user, response.data ])
            characters.select(response.data)
            modal.close()
            toaster.success('Character added successfully')
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const form = useFormBuilder({ formName, onSubmit: () => createCharacterRef.current(), controls: {
        name: { validators: [Validators.required] },
        server: { validators: [Validators.required] },
        alliance: {},
    } })

    const onServerChange = (serverId) => {
        if (serverId && !allianceOptions[serverId]) {
            koalition.get(`/servers/${serverId}/alliances`).then((response) => {
                const alliancesOptions = response.data.map((alliance) => ({ value: alliance._id, label: `${alliance.name} [${alliance.tag}]` }))
                
                setAllianceOptions((prev) => {
                    const allianceOptionsMap = { ...prev }
                    allianceOptionsMap[serverId] = [noAllianceOption, ...alliancesOptions]

                    return allianceOptionsMap
                })
            })
        }
        setCurrentServer(serverId)
    }

    useEffect(() => {
        koalition.get('/servers').then((response) => {
            setServerOptions(response.data.map((server) => ({ value: server._id, label: server.name })))
        }).catch((error) => {
            console.error(error)
        })

        modal.configure({ formName, submitLabel: 'Add' })
    }, [])

    return (
        <div className="row justify-content-center">
            <div className="col-lg-6 mb-3">
                <Input control={form.$state.controls.name} label="Name" />
            </div>

            <div className="col-sm-6 col-lg-2 mb-3">
                <Select control={form.$state.controls.server} options={serverOptions} onChange={onServerChange} label="Server" />
            </div>

            <div className="col-sm-6 col-lg-4 mb-3">
                <Select control={form.$state.controls.alliance} options={allianceOptions[currentServer] || []} label="Alliance" />
            </div>
        </div>
    )
}

export default NewCharacter